export default __webpack_public_path__ + "static/team1_tablet-7b7f9ef405bd165c8737833154cbee1a.jpg";